import { boot } from 'quasar/wrappers'
import langDict from 'lang/index'
const lang = {
  data: langDict,
  _getValue(dict, langId, id, clientId) {
    let result;
    if (clientId && clientId != '') {
      result = jng.getValueOfObject(dict, id + '.' + clientId + '.' + langId) 
    }
    if (!result) {
      result = jng.getValueOfObject(dict, id + '.' + langId)
    }
    return jng.coalesce(result, '')   
  },
  _convertToFunction(funcStr, value, langId, clientId) {
    let funcName = 'FUNC.__' + funcStr
    let funcParam = '\'' + value + '\''

    let funcList = funcStr.split('(')
    if (funcList.length > 1) {
      funcName = 'FUNC.__' + funcList[0]
      let params = funcList[1].getPart(0, ')')
      params = params.split(',')
      params.forEach(param => {
        funcParam += ", \'" + param.trim() + "\'"
      });
    }

    if ( jng.coalesce(clientId, '') != ''){
      if (jng.getValueOfObject(this.data, funcName + '.' + clientId)) {
        funcName = funcName + '.' + clientId
      }
    }
    
    return funcName + '.' + langId + '(' + funcParam + ')'
  },
  get(langId, id, clientId) {
    var idComponents = id.splitLastPart('__');
    if (idComponents.length == 2) {
      let result = this.get(langId, idComponents[0], clientId)
      let funcStr = this._convertToFunction(idComponents[1], result, langId, clientId)
      result = eval('this.data.' + funcStr)
      return result
    } else {
      return this._getValue(this.data, langId, id, clientId)
    }
    
  },
  getLC(langId, id, clientId) {
    return this.get(langId, id, clientId).toLowerCase()
  },
  getUC(langId, id, clientId) {
    return this.get(langId, id, clientId).toUpperCase()
  },
  getTC(langId, id, clientId) {
    return this.get(langId, id, clientId).toTitleCase()
  },
  getSC(langId, id, clientId) {
    return this.get(langId, id, clientId).toSentenceCase()
  },
}

export default boot(({ app }) => {
  app.config.globalProperties.jLang = lang
  app.provide('jLang', lang)
})

export { lang }
